import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Select, Button } from 'antd';
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import folders from '../../Actions/folders';
import { getCopy } from '../../helpers';
const { addRemoveFolderOption, updateCategorySelected } = folders.actions;
const { Option } = Select;

function SelectsOrganization (props) {
    const { data, maxOptions, options, id, label } = props;
    const [fileNaming, setData] = useState(data);
    useEffect(() => {setData(data) });

    const handleDrag = (result) => {
        if (!result.destination)
            return;
            const startIndex =  result.source.index;
            const endIndex =    result.destination.index;
        
            const fileNamingNew = Array.from(fileNaming);
            const [removed] = fileNamingNew.splice(startIndex, 1);
            fileNamingNew.splice(endIndex, 0, removed);
          
            setData(fileNamingNew);
            props.deleteDataFunction(fileNamingNew);
    };

    const addNewItem = (value, e) => {
        if(validateMaxOptionsToAdd()) {
            let { options } = props;
            let dataUpdated = options.find(f => { return f.selected === false });        
            dataUpdated.selected = true;
            props.addDataFunction(dataUpdated);            
        }
    }
    
    const removeItem = (folderToDelete) => {
        let { data, options } = props;
      
        if(data.length  !== 1) {
            let dataUpdated = options.find(categorie => {
                return categorie.value ===  folderToDelete;
            });
            
            dataUpdated.selected = false;
            let mergedData = data.map(f => (f.value === dataUpdated.value) ? dataUpdated : f);
            props.deleteDataFunction(mergedData);
        }
    }

    const handleOnchange = (newValue, element, previousValue)  => {
        let { data,options } = props;
        let newElement = options.find(item => item.value === newValue);
        let oldElement = options.find(item => item.value === previousValue);
        newElement.selected = true;
        oldElement.selected = false;
        const oldElementIndex = data.findIndex(item => item.value === previousValue);
        data[oldElementIndex] = { value: newElement.value , label: newElement.label, pathName: newElement.pathName, selected: true };
        props.updateDataFunction(getCopy(options),  getCopy(data));
    }

    const validateMaxOptionsToAdd = () => {
        let { data, maxOptions } = props;
       return maxOptions === data.length ? false : true;
    }   
    
        return (			
            <Fragment>
                <span className="block" style={{fontWeight: '500', marginTop: '20px'}}>{label}</span>
                <DragDropContext onDragEnd={handleDrag}>
                    <div className="folders-container">                
                    <Droppable droppableId={id}>
                    {(provided, snapshot) => (
                        <div
                        ref={provided.innerRef}     
                            {...provided.droppableProps}
                        >
                        {
                            fileNaming.map((item, index) => {                        
                                if(item.selected === true) {
                                    return (
                                        <Fragment key={index}>
                                            <Draggable draggableId={item.value} key={item.value} index={index} type="TASK">
                                                {
                                                    (provided, snapshot) => (
                                                <div
                                                    className="select-container"                                                        
                                                    ref={provided.innerRef}     
                                                    {...provided.draggableProps}                                                   
                                                    {...provided.dragHandleProps}
                                                >                      
                                                <Select                                       
                                                    defaultValue={item.label}
                                                    value={item.label}
                                                    style={{ width: 230 }}
                                                    onChange={(value,el) => handleOnchange(value,el, item.value)}                                                                                                                              
                                                    >					
                                                    { options && options.length > 0 &&
                                                        options.map((element, index) => {
                                                            if (element.selected === false) {
                                                                return (
                                                                    <Option key={`cat-${index}`} value={element.value}>
                                                                        {element.label}
                                                                    </Option>
                                                                );
                                                            } else { return null; }
                                                        })
                                                    }
                                                </Select>
                                                <Button                                             
                                                    name={item.value}
                                                    type="link"
                                                    onClick={()=>{removeItem(item.value)}}>
                                                    <CloseOutlined style={{color:'#f81d22',padding: '5px',fontSize: '15px'}} />
                                                </Button>
                                                </div>
                                                    )
                                                }                                                
                                            </Draggable>
                                        </Fragment>
                                    )
                                } else { return null; }                             
                            })                            
                        }
                        </div>
                    )}
                    </Droppable>
                    <div className="flex-container-align-vertically" style={{marginTop: '40px'}}>
                        <Button type="link" onClick={addNewItem}  style={{color: '#333'}}>
                            <PlusCircleOutlined style={{color:'#1890FF'}} />      
                            Agregar campo
                        </Button>
                        { !validateMaxOptionsToAdd() &&
                            <div className="warning-color">El máximo de campos a configurar es {maxOptions} </div>
                        }
                    </div>
                </div>
                </DragDropContext>
            </Fragment>
        );
    }


const mapDispatchToProps = dispatch => {
    return {
    	addRemoveFolderOption:(data) => {
            dispatch(addRemoveFolderOption(data));
        },
        updateCategorySelected:(data)  => {
            dispatch(updateCategorySelected(data));
        }
    }
}

export default connect(null,mapDispatchToProps)(SelectsOrganization);
